import React, { useState } from 'react';
import { renderToString } from 'react-dom/server'
import Spinner from '../../../Libraries/Loader';
import { useI18n } from '../../utilities/i18n';
import Api from '../Api';
import ProductRecommender from '../Maths/ProductRecommender';
import ProductRecommendation from './ProductRecommendation';
import Summary from './Summary';

const PrintView = function ({ pool, i18n, products }) {
    const scriptCode = `window.onload = function () {
        window.print();
    }`

    return <html style={{ background: '#fff' }}>
        <head>
            <title>{ pool.name}</title>
            <link id="css" rel="stylesheet" href={ i18n.print.css } />
            <script dangerouslySetInnerHTML={ { __html: scriptCode } }/>
        </head>
        <body style={{ background: '#fff' }}>
            <div className="p-10">
                <header className="container mx-auto">
                    <div>
                        <img style={{ height: 20 }} className="w-auto" id="logo" src={ i18n.print.logo } alt="Dantherm Group Logo" />
                    </div>
                    { i18n.print.brand ? <div className="mt-10">
                        <img style={{ height: 40 }} className="w-auto" id="brand" src={ i18n.print.brand } alt="Brand Logo" />
                    </div> : null }
                </header>

                <main className="mt-10 container mx-auto">
                    <h1 className="text-3xl font-bold">
                        { pool.name }
                    </h1>

                    <div className="mt-6">
                        <Summary links={ false } pool={ pool } i18n={ i18n } />
                    </div>

                    <div style={{
                        pageBreakBefore: 'always',
                    }}/>

                    <h2 className="text-2xl font-bold mt-10">
                        { i18n.print.heading }
                    </h2>

                    { products.length ? <div className="mt-12 space-y-10">
                        { products.map((product, index) => <ProductRecommendation key={index} product={product} i18nRecommendations={i18n.recommendations} />) }
                    </div> : <p>
                        { i18n.print.noProducts }
                    </p> }

                </main>
            </div>
        </body>
    </html>
}

export default function PrintButton({ children, id }) {
    const i18n = useI18n()
    const [busy, setBusy] = useState(false)
    const isFirefox = navigator.userAgent.toLowerCase().indexOf('firefox') > -1;

    const onClick = async () => {
        setBusy(true)

        const popup = window.open(isFirefox ? window.location.href : 'about:blank').document;

        const { data } = await Api.getPool(id)

        const products = (await ProductRecommender(data)).products.map(product => {
            const match = (data.selected_products || []).find(p => {
                return `${ p.product_id }` === `${ product.model.product_id }` && `${ p.model }` === `${ product.model.model }`
            })

            return match ? product : null;
        }).filter(p => p);

        const popupHtml = renderToString(
            <PrintView products={ products } pool={ data } i18n={ i18n } />,
        );

        if (isFirefox) {
            popup.open();
        }

        popup.write(popupHtml);
        popup.close();

        setBusy(false)
    }

    return <button className="appearance-none relative leading-none inline-flex items-center hover:text-green focus:outline-none" type="button" onClick={onClick}>
        <span className={`inline-block ${busy ? 'opacity-25' : ''}`}>
            { children }
        </span>
        { busy ? <span className={'mt-0.5 absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 transform'}>
            <Spinner colour="#7d7d7d" />
        </span> : null }
    </button>;
}
